import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { isBulkOrBulkIntegrationEnabledSelector } from '@/selectors'

const Quantity = ({ quantity }) => {
  const isBulkOrBulkIntegrationEnabled = useSelector(
    isBulkOrBulkIntegrationEnabledSelector
  )

  return (
    <If condition={isBulkOrBulkIntegrationEnabled}>
      <div className='item-quantity d-flex flex-row align-items-baseline'>
        <p className='qa-item-quantity u-flush'>
          <FormattedMessage id='common.quantity' />{': '}{quantity}
        </p>
      </div>
    </If>
  )
}

Quantity.propTypes = { quantity: PropTypes.number.isRequired }

export default Quantity
